<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{ name: 'home' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">QRIS Merchant</div>
            <div class="right">
                <a class="headerButton" @click="refreshData()">
                    <ion-icon name="sync-sharp"></ion-icon>
                </a>
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div>
                <div
                    class="section detail-transaction-section"
                    style="--height: 60px; padding-top: 5px"
                >
                    <div class="detail-card">
                        <div class="row">
                            <div class="col-3">
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="require('@/assets/qris.png')"
                                    alt="image"
                                    class="w-100"
                                    style="border-radius: 5px"
                                    @click="showImageQris('show')"
                                />
                                <div
                                    class="text-center"
                                    style="
                                        font-size: 8px;
                                        line-height: 10px;
                                        margin-top: 3px;
                                    "
                                >
                                    Klik untuk<br />memperbesar
                                </div>
                            </div>
                            <div class="col-9">
                                <div class="row">
                                    <div class="col-6 text-left">
                                        <span
                                            style="
                                                font-size: 13px;
                                                color: #17273e;
                                            "
                                            >Saldo
                                            {{ VUE_ENV.VUE_APP_NAME }}</span
                                        >
                                        <h1
                                            class="text-primary"
                                            :class="{
                                                'loading-component':
                                                    loading.content,
                                            }"
                                            style="font-size: 14px"
                                            @click="getCustomer()"
                                        >
                                            <span
                                                >Rp
                                                {{
                                                    customer.balance | rupiah
                                                }}</span
                                            >
                                        </h1>
                                    </div>
                                    <div class="col-6 text-right">
                                        <span
                                            style="
                                                font-size: 13px;
                                                color: #17273e;
                                            "
                                            >Saldo QRIS</span
                                        >
                                        <h1
                                            class="text-primary"
                                            :class="{
                                                'loading-component':
                                                    loading.content,
                                            }"
                                            style="font-size: 14px"
                                        >
                                            <span
                                                >Rp
                                                {{
                                                    qris_summary.qris_balance
                                                        | rupiah
                                                }}</span
                                            >
                                        </h1>
                                    </div>
                                </div>
                                <div class="row">
                                    <div
                                        style="
                                            padding-left: 8px;
                                            padding-right: 8px;
                                        "
                                    >
                                        <!-- <router-link
                                            :to="{
                                                name: 'qris.payment.data',
                                            }"
                                            class="btn btn-sm btn-primary pl-2 pr-2 mr-1"
                                            style="border-radius: 100px"
                                        >
                                            Riwayat
                                        </router-link> -->
                                        <router-link
                                            :to="{
                                                name: 'sendmoney.order',
                                                params: {
                                                    title: 'Kirim Uang',
                                                    transfer_method_selected:
                                                        'TRANSFER_ONLINE',
                                                },
                                            }"
                                            class="btn btn-sm btn-primary pl-2 pr-2"
                                            style="border-radius: 100px"
                                            >Tarik Saldo</router-link
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section mt-2 mb-2">
                    <ul class="listview image-listview inset m-0">
                        <li>
                            <router-link
                                :to="{ name: 'qris.list' }"
                                class="item"
                            >
                                <div class="icon-box bg-light">
                                    <ion-icon
                                        name="storefront-outline"
                                    ></ion-icon>
                                </div>
                                <div class="in">
                                    <div>
                                        <div>QRIS Merchant</div>
                                        <footer>
                                            Lihat QRIS Merchant Lainnya
                                        </footer>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{ name: 'qris.settlement.data' }"
                                class="item"
                            >
                                <div class="icon-box bg-light">
                                    <ion-icon
                                        name="calendar-outline"
                                    ></ion-icon>
                                </div>
                                <div class="in">
                                    <div>
                                        <div>Settlement</div>
                                        <footer>
                                            Pencairan Saldo QRIS ke Saldo
                                            {{ VUE_ENV.VUE_APP_NAME }}
                                        </footer>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{
                                    name: 'tos.detail',
                                    params: { id: 'qris' },
                                }"
                                class="item"
                            >
                                <div class="icon-box bg-light">
                                    <ion-icon
                                        name="clipboard-outline"
                                    ></ion-icon>
                                </div>
                                <div class="in">
                                    <div>
                                        <div>Syarat & Ketentuan</div>
                                        <footer>
                                            Baca Syarat & Ketentuan Layanan
                                        </footer>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                    </ul>

                    <!-- * Banner Informasi & Promo -->
                    <!-- <div class="section full mb-2">
                        <img
                            v-lazyload
                            :src="require('@/assets/loading_banner.jpg')"
                            :data-src="
                                require('@/assets/banner_coming_qris.jpg')
                            "
                            alt="image"
                            class="w-100"
                            style="border-radius: 10px"
                            @click="showAlertComing('show')"
                        />
                    </div> -->
                </div>
                <div class="section full mt-3">
                    <div class="section-heading padding mb-1">
                        <h2 class="title" style="font-size: 13px">
                            Transaksi Terbaru Hari Ini
                        </h2>
                        <router-link
                            class="link"
                            :to="{
                                name: 'qris.payment.data',
                            }"
                        >
                            Lihat Semua
                        </router-link>
                    </div>
                    <div>
                        <div
                            class="text-center mt-5 pt-5 mb-5 pb-5"
                            v-if="loadingPaymentData"
                        >
                            <span
                                class="spinner-border spinner-border mr-1 text-primary"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        </div>
                        <div v-else-if="qris_payments.data.length > 0">
                            <!-- item -->
                            <ul
                                class="listview image-listview-product full ml-0 mr-0"
                            >
                                <li
                                    v-for="item in sortedDataQrisPayment.slice(
                                        0,
                                        10
                                    )"
                                    :key="item.id"
                                >
                                    <router-link
                                        :to="{
                                            name: 'qris.payment.detail',
                                            params: {
                                                id: item.id,
                                            },
                                        }"
                                        class="item pl-2 pr-3 pt-2 pb-2"
                                    >
                                        <div class="in">
                                            <div style="width: 90%">
                                                <header>
                                                    {{ item.paid_at | date }}
                                                    ({{ item.paid_at | time }}
                                                    WIB)
                                                </header>
                                                <b>{{
                                                    item.qris_merchant
                                                        .merchant_name
                                                }}</b>
                                                <footer>
                                                    <div>
                                                        Issuer :
                                                        {{
                                                            JSON.parse(
                                                                item.reference_data
                                                            ).issuer
                                                        }}
                                                    </div>
                                                    <div>
                                                        RRN :
                                                        {{
                                                            JSON.parse(
                                                                item.reference_data
                                                            ).rrn
                                                        }}
                                                    </div>
                                                </footer>
                                            </div>
                                        </div>
                                        <span class="text-muted text-right">
                                            <h4>
                                                Rp
                                                {{ item.amount | rupiah }}
                                            </h4>
                                        </span>
                                    </router-link>
                                </li>
                            </ul>
                            <div class="text-center mt-2 mb-5">
                                <router-link
                                    :to="{
                                        name: 'qris.payment.data',
                                    }"
                                    class="btn btn-primary pl-2 pr-2 mr-1"
                                    style="border-radius: 100px"
                                >
                                    Lihat Semua Riwayat
                                </router-link>
                            </div>
                        </div>
                        <div class="text-center" v-else>
                            <img
                                :src="require('@/assets/image/empty.webp')"
                                alt="404"
                                class="w-50"
                            /><br />
                            <h4 class="mb-0 text-secondary">
                                Belum ada transaksi
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <action-sheet
            ref="show_image_qris"
            :title="''"
            :header="false"
            :inset="true"
            :content-full="false"
            :contentHeight="false"
            :fullDisplay="true"
            :footer="true"
        >
            <div class="col-12">
                <div v-if="qris_merchant_data.url_qris_image">
                    <img
                        v-lazyload
                        :src="require('@/assets/Loader-2.png')"
                        :data-src="qris_merchant_data.url_qris_image"
                        alt="image"
                        class="w-100 mb-2"
                        style="border-radius: 5px"
                    />
                </div>
                <div class="text-center" v-else>
                    <img
                        :src="require('@/assets/image/empty.webp')"
                        alt="404"
                        class="w-50"
                    /><br />
                    <h4 class="mb-0 text-secondary">
                        Belum ada QRIS yang aktif
                    </h4>
                </div>
            </div>
            <template #footer>
                <button
                    class="btn btn-primary btn-block"
                    @click="buttonChangeDefaultQris()"
                >
                    <ion-icon name="cog-outline"></ion-icon> Atur Default QRIS
                </button>
                <button
                    class="btn btn-outline-primary btn-block"
                    @click="downloadImageQRIS()"
                    v-if="qris_merchant_data.url_qris_image"
                >
                    <ion-icon name="cloud-download-outline"></ion-icon> Download
                </button>
                <button
                    class="btn btn-outline-primary btn-block"
                    @click="showImageQris('hide')"
                >
                    Tutup
                </button>
            </template>
        </action-sheet>
        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_coming"
            :loading="false"
            :title="'Informasi'"
            @confirm="showAlertComing('hide')"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Fitur ini masih dalam pengembangan dan akan segera tersedia,
                saat fitur ini sudah tersedia akan kami informasikan.</span
            >
        </Dialog>
    </div>
</template>
<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    export default {
        data() {
            return {
                loading: {
                    content: false,
                },
                loadingApp: false,
                loadingPaymentData: false,
                loadingButton: false,
            };
        },
        created() {
            this.loadingApp = true;
            this.loadingPaymentData = true;
            this.getQrisMerchantDefault()
                .then(() => {
                    this.loadingApp = false;
                    this.getQrisPayment().then(() => {
                        this.loadingPaymentData = false;
                    });
                    window.Echo.private(
                        `customer-business.${this.qris_merchant_data.customer_business_id}`
                    ).listen('.qris-payment.created', e => {
                        this.qris_payments.data.push(e);
                    });
                })
                .catch(() => {
                    this.loadingApp = false;
                    this.$router.push({
                        name: 'qris.register',
                        params: { opening: true },
                    });
                });
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('qrisMerchant', {
                qris_summary: state => state.qris_summary,
                qris_merchant_data: state => state.qris_merchant_data,
                qris_payments: state => state.qris_payments,
            }),
            sortedDataQrisPayment: function () {
                return this.qris_payments.data.slice().sort((a, b) => {
                    return new Date(b.paid_at) - new Date(a.paid_at);
                });
            },
        },
        methods: {
            ...mapActions(['getCustomer']),
            ...mapActions('qrisMerchant', [
                'getQrisMerchantDefault',
                'getQrisPayment',
            ]),
            ...mapMutations('qrisMerchant', [
                'RESET_QRIS_PAYMENT',
                'RESET_QRIS_MERCHANT_DATA',
            ]),
            showImageQris(value) {
                let element = this.$refs.show_image_qris.$el;
                window.$(element).modal(value);
            },
            showAlertComing(value) {
                let element = this.$refs.dialog_alert_coming.$el;
                window.$(element).modal(value);
            },
            buttonChangeDefaultQris() {
                this.showImageQris('hide');
                this.$router.push({ name: 'qris.list' });
            },
            refreshData() {
                this.RESET_QRIS_PAYMENT();
                this.loadingApp = true;
                this.getQrisPayment().then(() => {
                    this.loadingApp = false;
                });
                this.getCustomer();
            },
            downloadImageQRIS() {
                const link = document.createElement('a');
                link.href = this.qris_merchant_data.url_qris_image; // ganti dengan URL gambar
                link.download =
                    'qris-' + this.qris_merchant_data.merchant_name + '.jpg'; // nama file saat di-download
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
        },

        mounted() {},
        destroyed() {
            this.RESET_QRIS_PAYMENT();
            this.RESET_QRIS_MERCHANT_DATA();
        },
    };
</script>
<style>
    .table-min th,
    .table-min td {
        padding: 0.5rem 0.75rem 0.5rem 0.75rem;
    }
</style>
